import {
  SET_PRINT_BLOB_URL,
  SET_PRINT_FIT_MAP,
  SET_PRINT_INCLUDES_MAP,
  SET_PRINT_MAP_CURRENT_SCALE,
  SET_PRINT_MAP_DPI,
  SET_PRINT_ORIENTATION,
  SET_PRINT_SCALE,
  SET_PRINT_SIDE_PANEL,
  SET_PRINT_SIZE,
  SET_PRINT_STATS,
  SET_PRINT_TITLE,
  SET_PRINT_UI_CLOSE,
  SET_PRINT_UI_OPEN
} from './actions'

export const printSidePanel = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_SIDE_PANEL:
      return action.printSidePanel
    default:
      return state
  }
}

export const printIncludesMap = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_INCLUDES_MAP:
      return action.printIncludesMap
    default:
      return state
  }
}

export const printFitMap = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_FIT_MAP:
      return action.printFitMap
    default:
      return state
  }
}

export const printStats = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_STATS:
      return action.printStats
    default:
      return state
  }
}

export const printTitle = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_TITLE:
      return action.printTitle
    default:
      return state
  }
}

export const printUIVisible = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_UI_OPEN:
    case SET_PRINT_UI_CLOSE:
      return action.printUIVisible
    default:
      return state
  }
}

export const printSize = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_SIZE:
      return action.printSize
    default:
      return state
  }
}

export const printOrientation = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_ORIENTATION:
      return action.printOrientation
    default:
      return state
  }
}

export const printBlobURL = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_BLOB_URL:
      return action.printBlobURL
    default:
      return state
  }
}

export const printMapCurrentScale = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_MAP_CURRENT_SCALE:
      return action.printMapCurrentScale
    default:
      return state
  }
}

export const printMapDpi = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_MAP_DPI:
      return action.printMapDpi
    default:
      return state
  }
}

export const printScale = (state = null, action) => {
  switch (action.type) {
    case SET_PRINT_SCALE:
      return action.printScale
    default:
      return state
  }
}
